var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complete box"},[_c('h1',{staticClass:"has-text-weight-bold"},[_vm._v("THANK YOU FOR YOUR REQUEST")]),_c('p',{staticClass:"has-text-weight-normal"},[_vm._v("We have received your upgrade request and will respond shortly.")]),_c('LeaveReview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }